import { Pipe, PipeTransform } from '@angular/core';

/**
 * Expected input formats 00:00 or 00:00:00
 */
@Pipe({
    name: 'timeWithoutSeconds',
    standalone: true
})
export class TimeWithoutSecondsPipe implements PipeTransform {

  transform(value: string | undefined, ...args: unknown[]): string | undefined {
    if(value?.split(':').length === 2) {
      return value;
    }
    return value?.substring(0, value.lastIndexOf(":"));
  }

}
